import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = { class: "table-scroll" }
const _hoisted_3 = { class: "table-financial" }
const _hoisted_4 = { class: "table-col" }
const _hoisted_5 = { class: "col-content" }
const _hoisted_6 = { class: "cell col-title header" }
const _hoisted_7 = { class: "cell col-title" }
const _hoisted_8 = { class: "cell__title" }
const _hoisted_9 = { class: "cell col-title" }
const _hoisted_10 = { class: "cell__title-group" }
const _hoisted_11 = { class: "cell__title" }
const _hoisted_12 = { class: "cell col-title" }
const _hoisted_13 = { class: "cell__title-group" }
const _hoisted_14 = { class: "cell__title" }
const _hoisted_15 = { class: "cell col-title" }
const _hoisted_16 = { class: "cell__title" }
const _hoisted_17 = { class: "cell col-title" }
const _hoisted_18 = { class: "cell__title" }
const _hoisted_19 = { class: "cell col-title" }
const _hoisted_20 = { class: "cell__title-group" }
const _hoisted_21 = { class: "cell__title" }
const _hoisted_22 = { class: "cell col-title" }
const _hoisted_23 = { class: "cell__title-group" }
const _hoisted_24 = { class: "cell__title" }

import { computed } from "vue";
import useToggleableTable from "@/composables/UseToggleableTable";
import TableFinancialDataColumn from "./TableFinancialDataColumn.vue";
import dayjs from "dayjs";
import IconButton from "./IconButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableFinancialData',
  props: {
    id: {},
    startDate: {}
  },
  emits: ["goBack", "goForwards"],
  setup(__props: any, { emit: __emit }) {

const { toggle, isToggled } = useToggleableTable("financialTable", [
  "ordered",
  "invoicedNet",
  "invoicedGross",
]);

const props = __props;

const emits = __emit;

const currentYear = computed(() => {
  return props.startDate.format("YYYY");
});

const months = computed(() => {
  const year = props.startDate.startOf("y").format("YYYY");
  return [...Array(12).keys()].map(
    (_, i) => `${year}-${dayjs().month(i).format("MM")}-01`,
  );
});

const clickColumnHeader = (i: number) => {
  if (i === 0) {
    emits("goBack");
  } else if (i === months.value?.length - 1) {
    emits("goForwards");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, _toDisplayString(currentYear.value), 1),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("div", {
                class: "cell__title-group cell__title-group--clickable",
                onClick: _cache[0] || (_cache[0] = () => _unref(toggle)('ordered'))
              }, [
                _createVNode(IconButton, {
                  iconName: "mdi:chevron-right",
                  size: "sm",
                  class: _normalizeClass([
                    'toggle',
                    {
                      'toggle--open': _unref(isToggled)('ordered'),
                    },
                  ])
                }, null, 8, ["class"]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("labels.ordered")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("labels.workedGross")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("labels.expenseGross")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createElementVNode("div", {
                class: "cell__title-group cell__title-group--clickable",
                onClick: _cache[1] || (_cache[1] = () => _unref(toggle)('invoicedNet'))
              }, [
                _createVNode(IconButton, {
                  iconName: "mdi:chevron-right",
                  size: "sm",
                  class: _normalizeClass([
                    'toggle',
                    {
                      'toggle--open': _unref(isToggled)('invoicedNet'),
                    },
                  ])
                }, null, 8, ["class"]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("labels.invoicedNet")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("div", {
                class: "cell__title-group cell__title-group--clickable",
                onClick: _cache[2] || (_cache[2] = () => _unref(toggle)('invoicedGross'))
              }, [
                _createVNode(IconButton, {
                  iconName: "mdi:chevron-right",
                  size: "sm",
                  class: _normalizeClass([
                    'toggle',
                    {
                      'toggle--open': _unref(isToggled)('invoicedGross'),
                    },
                  ])
                }, null, 8, ["class"]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("labels.invoicedGross")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("labels.paid")), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("labels.toBePaid")), 1)
              ])
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, i) => {
          return (_openBlock(), _createBlock(TableFinancialDataColumn, {
            key: month,
            projectId: __props.id,
            month: month,
            column: i + 2,
            "is-first": i === 0,
            "is-last": i === months.value.length - 1,
            onClickHeader: () => clickColumnHeader(i)
          }, null, 8, ["projectId", "month", "column", "is-first", "is-last", "onClickHeader"]))
        }), 128)),
        (_openBlock(), _createBlock(TableFinancialDataColumn, {
          key: currentYear.value,
          projectId: __props.id,
          year: currentYear.value,
          column: 14
        }, null, 8, ["projectId", "year"])),
        (_openBlock(), _createBlock(TableFinancialDataColumn, {
          key: 'Until' + currentYear.value,
          projectId: __props.id,
          until: currentYear.value,
          column: 15
        }, null, 8, ["projectId", "until"]))
      ])
    ])
  ]))
}
}

})